<template>
    <div>
        <my-table :data="tableData">
            <el-table-column label="费用编码" prop="fycode"  min-width="200"></el-table-column>
            <el-table-column label="费用名称" prop="fyname"  min-width="200"></el-table-column>
            <el-table-column label="费用类型" prop="fytype"  min-width="200"></el-table-column>
            <el-table-column label="费用金额" prop="fyje" min-width="150"></el-table-column>
        </my-table>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [ LIST_PAGE_MIXIN ],
    props: {
        row: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        var that = this;
        return {
            pgData: {
                sortname: 'zbprocode',
                orderscode: that.row.orderscode
            }
        }
    },
    methods: {
        queryData() {
            this.$get(`${this.getGetters('mngUrl')}/manage/finance/auditbsk/detail.json`, {
                orderscode: this.row.orderscode
            }, data => {
                this.tableData = data;
            });
        }
    },
    mounted() {
        this.queryData();
    }
}
</script>

<style lang="scss" scoped>

</style>